import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public error: boolean;
  public sessionExpired: boolean = false;
  public isSending: boolean = false;

  constructor(private formBuilder: FormBuilder, private apiService: ApiService, private router: Router) {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      strategy: ['local']
    });
  }

  ngOnInit() {
    this.sessionExpired = (localStorage.getItem('sessionExpired') == 'true');
  }

  submitLoginForm() {
    this.isSending = true;

    this.apiService.authenticate(this.loginForm.value).then((token) => {
        this.router.navigateByUrl('users');
        this.isSending = false;
    }, (err) => {
        this.error = true;
        this.isSending = false;
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts